
<router-outlet (activate)="onActivate($event)" ></router-outlet>

